import { CAPABILITIES } from "@/lib/content";
import { SectionLabel, RevealLines } from "../site/motion";

export const CapabilityList = () => {
  return (
    <section data-testid="services-capabilities" className="py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <SectionLabel n="(02)">Capabilities</SectionLabel>
        <RevealLines inView as="h2" lines={["Six capabilities,", "one standard."]}
          className="mt-6 font-display text-4xl font-semibold uppercase leading-[0.95] tracking-[-0.03em] text-cream sm:text-5xl lg:text-7xl"
          lineClass={(i) => (i === 1 ? "text-cream/55" : "")} />
        <div className="relative mt-16 border-t border-cream/10">
          {CAPABILITIES.map((c) => (
            <div key={c.key} data-testid={`capability-row-${c.key}`}
              className="group relative grid gap-3 border-b border-cream/10 py-8 md:grid-cols-12 md:items-center md:py-10">
              <span className="font-mono text-xs text-skaris-sky md:col-span-1">{c.n}</span>
              <h3 className="font-display text-3xl font-semibold uppercase tracking-tight text-cream transition-[transform,color] duration-500 group-hover:translate-x-3 group-hover:text-skaris-glow md:col-span-6 md:text-5xl">{c.title}</h3>
              <p className="font-body text-sm leading-relaxed text-cream/75 md:col-span-4 md:col-start-9">{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
